import zh from "./i18n/zh";
import en from "./i18n/en";

export default {
  "en-us": en,
  zh_CN: zh
};
